export default class PrivateLeagueParamUpdateBody {
  public name: string = "";
  public description: string = "";
  public invitationCode: string = "";
  public templateId: string = "";
  public usersCanInviteUsers: boolean = false;
  public administrators: string[] = [];
  public pinnedPosts: string[] = [];
  public scoringStartsAt: string = "";
}
